// extracted by mini-css-extract-plugin
export var infoItem = "_u1-2";
export var title = "_u1-0";
export var value = "_u1-1";